import { AgGridReact } from 'ag-grid-react';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { getFormattedValue } from '../../../../../appFunctions';
import { ColDef } from 'ag-grid-community';
import CurrentPeriodPositiveIcon from "../../../../../svg/Ads_Dashboard_Developement2/CurrentPeriodPositiveIcon/elements.svg";
import CurrentPeriodNegativeIcon from "../../../../../svg/Ads_Dashboard_Developement2/CurrentPeriodNegativeIcon/elements.svg";
import CalenderIcon from "../../../../../svg/Ads_Dashboard_Developement2/CalenderIcon/elements.svg";

import { BASE_URL, BLACK } from '../../../../../appConstants';
import appError from '../../../../../appError';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { CircularProgress } from '@mui/joy';
import CheckedIcon from "../../../../../svg/Ads_Dashboard_Developement2/CheckedIcon/elements.svg";
import UnCheckedIcon from "../../../../../svg/Ads_Dashboard_Developement2/UnCheckedIcon/elements.svg";
type DateProps = {
  startDate: Date;
  endDate: Date;
};
type Range = {
  rangeOne: DateProps;
  rangeTwo: DateProps;
};
type GraphTableDrawerProps = {
  setGraphTableToggle: Dispatch<SetStateAction<boolean>>;
  graphTableArr: any[];
  InputRange: Range;
}
const GraphTableDrawer: React.FC<GraphTableDrawerProps> = ({setGraphTableToggle, graphTableArr, InputRange}) => {

  const { brand_id } = useParams();

  const MatricesNameRenderer = (params: any) => {
        return (
          <div className="flex w-full px-4 py-2 items-center justify-start self-stretch gap-2">
            <div
              style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                textAlign: "right",
                fontFamily: "Inter",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "18px",
              }}
            >
              {params?.data?.matrice_name}
            </div>
          </div>
        );
      };
    
  const CurrentRenderer = (params: any) => {
    const {
      backend_matrice_name,
      base_period = 0,
      comparison_period = 0,
    } = params?.data;
    const baseValue = Number(base_period);
  const comparisonValue = Number(comparison_period);

  const negativeGrowthMetrics = ["spend", "acos", "tacos", "cpc", "cac"]; // Lower is better

  // Determine if the change is positive based on the metric type
  const isPositiveTrend = negativeGrowthMetrics.includes(backend_matrice_name)
    ? comparisonValue > baseValue // if base is less = good
    : baseValue > comparisonValue; // if base is more = good
  const isDifferent = baseValue !== comparisonValue;

    return (
      <div className="flex w-full px-4 py-2 items-center justify-end self-stretch gap-2">
        <div
          className=""
          style={{
            textAlign: "center",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
          {getFormattedValue(params?.data?.base_period)}
        </div>
        {isDifferent && (<div
          className="flex p-1 w-[22px] items-center gap-1 rounded-[4px]"
          style={{
            backgroundColor: isPositiveTrend ? "#DEF7E4" : "#FFECEB",
          }}
        >
          <img
            src={
              isPositiveTrend
                ? CurrentPeriodPositiveIcon
                : CurrentPeriodNegativeIcon
            }
            alt="Icon"
            style={{ cursor: "pointer" }}
          />
        </div>)}
      </div>
    );
  };

  const ComparisonPeriodRenderer = (params: any) => {
      return (
        <div className="flex px-4 py-2 w-full items-center justify-end self-stretch gap-2">
          <div
            className=""
            style={{
              textAlign: "center",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "18px",
              color: "#1C1C1E",
            }}
          >
            {getFormattedValue(params?.data?.comparison_period)}
          </div>
        </div>
      );
    };

  const DiffRenderer = (params: any) => {
    const { backend_matrice_name, base_period = 0, comparison_period = 0 } = params?.data;
    console.log('-->', params?.data);
    const difference = Number(base_period) - Number(comparison_period);
    const decimaldigitsMetrics = ["acos","tacos","roas","troas","ctr","cvr","cpc","aov","cac","ad_sales_perc","organic_sales_perc" ];

    const absoluteDifference = decimaldigitsMetrics.includes(backend_matrice_name) ? (Number(difference?.toFixed(2))) : (difference);

    // Matrices where lower values are better
    const negativeGrowthMetrics = ["spend","acos","tacos", "cpc", "cac" ];

    const isPositiveTrend = negativeGrowthMetrics.includes(backend_matrice_name)
      ? Number(comparison_period) > Number(base_period) // These should be lower
      : Number(comparison_period) < Number(base_period); // Others should be higher

    const isSame = Number(comparison_period) === Number(base_period);

    const color = isSame
      ? "#1C1C1E" // neutral
      : isPositiveTrend
      ? "#186846" // green
      : "#D10C00"; // red
    return (
      <div className="flex w-full px-4 py-2 items-center justify-end self-stretch gap-2">
        <div
          style={{
            color: color,
            textAlign: "end",
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "18px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {getFormattedValue(params?.data?.difference)}
        </div>
      </div>
    );
  };

  const DiffInPercentageRenderer = (params: any) => {
    const basePeriod = Number(params?.data?.base_period ?? "0"); 
    const comparisonPeriod = Number(params?.data?.comparison_period ?? "0"); 
    const backend_matrice_name = params?.data?.backend_matrice_name;
    // Ensure the values are treated as numbers, and the difference calculation is correct.
    const difference = basePeriod - comparisonPeriod;
  
    let diffPercentage = 0;

    if (comparisonPeriod !== 0) {
      diffPercentage = (difference / comparisonPeriod) * 100;
    }
    const decimaldigitsMetrics = ["acos","tacos","roas","troas","ctr","cvr","cpc","aov","cac","ad_sales_perc","organic_sales_perc" ];

    const formattedPercentage = decimaldigitsMetrics.includes(backend_matrice_name)
    ? Number(diffPercentage.toFixed(2))
    : Math.round(diffPercentage);

    const isSame = basePeriod === comparisonPeriod;

    const negativeGrowthMetrics = ["spend", "acos","tacos", "cpc", "cac" ];
    const isPositiveTrend = negativeGrowthMetrics.includes(backend_matrice_name)
      ? comparisonPeriod > basePeriod  // lower is better, so if base is lower = green
      : basePeriod > comparisonPeriod; // higher is better

    const color = isSame
      ? "#1C1C1E"
      : isPositiveTrend
      ? "#186846"
      : "#D10C00";

    return (
      <div className="flex w-full px-4 py-2 items-center justify-end self-stretch gap-2">
        <div
          className=""
          style={{
            color: color,
            textAlign: "center",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "18px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {`${getFormattedValue(params?.data?.difference_percentage)} %`}
        </div>
      </div>
    );
  };

  const CheckboxHeaderCmp = (params: any) =>{
    return (
        <div style={{
            display: "flex",
            padding: "13px 12px 13px 12px",
            justifyContent: "start",
            alignItems: 'center',
            // backgroundColor: "#F9F9FB",
            width: "full",
            height: "100%"
        }} >
            Checkbox
        </div>
      )
  };
  const [sel_matricesGraph, setSel_matricesGraph] = useState<string[]>([]);
  const CheckboxCellRendererCmp = (params: any) =>{
    return (
        <div style={{
            display: "flex",
            padding: "8px 12px",
            justifyContent: "start",
            alignItems: "center",
            width: "fit-content",
        }} >
            {
                params?.data?.selected ? (
                    <img
                    src={CheckedIcon}
                    alt="Icon"
                    style={{ cursor: "pointer" }}
                    onClick={()=> {
                        if(sel_matricesGraph?.length > 1){
                          setTableData((prevData: any[]) => {
                            console.log('-->', prevData);
                            let new_data = prevData.map((item: any) =>
                              item.backend_matrice_name === params?.data?.backend_matrice_name
                                ? { ...item, selected: false }
                                : item
                            );
                            setSel_matricesGraph(new_data?.filter(item => item?.selected)?.map(item => item?.backend_matrice_name));
                            return new_data;
                            }
                          );
                        }
                        else {
                          appError("Minimum 1 matrice needs to be selected");
                        }
                      }
                    }
                    />
                ) : (
                    <img
                    src={UnCheckedIcon}
                    alt="Icon"
                    style={{ cursor: "pointer" }}
                    onClick={()=> {
                        if(sel_matricesGraph?.length < 4){
                          setTableData((prevData: any[]) =>{
                              let new_data = prevData.map((item: any) =>
                                item.backend_matrice_name === params?.data?.backend_matrice_name
                                  ? { ...item, selected: true }
                                  : item
                              );
                              setSel_matricesGraph(new_data?.filter(item => item?.selected)?.map(item => item?.backend_matrice_name));
                              return new_data;
                            }
                          )
                        } else {
                          appError("Maximum 4 matrices can be selected");
                        }
                      }
                    }
                    />
                )
            }
        </div>
      )
  };
  const [tableData, setTableData] = useState<any[]>([]); 

  const verticalcolDefs: ColDef<any>[] = [
        {
          field: "selected",
          headerName: "Checkbox",
          sortable: false,
          cellRenderer: CheckboxCellRendererCmp,
          headerComponent: CheckboxHeaderCmp,
          headerClass: 'custom-header-style',
          // cellStyle: {padding: '0px', backgroundColor: "#FFF"}
          minWidth: 100,
          flex: 1
      },
      {
        field: "matrice_name",
        headerName: "Matrices",
        sortable: false,
        cellRenderer: MatricesNameRenderer,
        // headerComponent: MatriceNameHeaderCmp,
        minWidth: 170,
        flex: 1
      },
      {
        field: "base_period",
        headerName: "Current Period",
        sortable: false,
        cellRenderer: CurrentRenderer,
        // headerComponent: CurrentHeaderCmp,
        minWidth: 140,
        flex: 1
      },
      {
        field: "comparison_period",
        headerName: "Comparison Period",
        sortable: false,
        cellRenderer: ComparisonPeriodRenderer,
        // headerComponent: ComparisonHeaderCmp,
        minWidth: 140,
        flex: 1
      },
      {
        field: "difference",
        headerName: "Difference",
        sortable: false,
        cellRenderer: DiffRenderer,
        // headerComponent: DiffHeaderCmp,
        minWidth: 140,
        flex: 1
      },
      {
        field: "diffPercentage",
        headerName: "Difference %",
        sortable: false,
        cellRenderer: DiffInPercentageRenderer,
        // headerComponent: DiffPercentageHeaderCmp,
        minWidth: 150,
        flex: 1
      },
    ];
  
  const [loading, setLoading] = useState<boolean>(false); // Loader for Table
  const [datafetchingState, setDataFetchingState] = useState<string>("");
  const [selproduct_details_arr, setSelProduct_details_arr] = useState<string[]>(["principal_category","main_category","category","sub_category", 'product_name', 'platform_code']);

  const fetchTableData = async (products_details_arr: string[]) => {

    let temp_obj = {
      filter: {
        current_data_range: {
          start_date: `${InputRange?.rangeOne?.startDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeOne?.endDate?.getFullYear()}-${String(
            InputRange?.rangeOne?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeOne?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        previous_data_range: {
          start_date: `${InputRange?.rangeTwo?.startDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.startDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.startDate?.getDate()
          ).padStart(2, "0")}`,

          end_date: `${InputRange?.rangeTwo?.endDate?.getFullYear()}-${String(
            InputRange?.rangeTwo?.endDate?.getMonth() + 1
          ).padStart(2, "0")}-${String(
            InputRange?.rangeTwo?.endDate?.getDate()
          ).padStart(2, "0")}`,
        },
        product_detail_filter: {
          [graphTableArr[graphTableArr?.length - 1]?.type] : [graphTableArr[graphTableArr?.length - 1]?.name]
        },
      },
      conditions: [],
      sort: {},
      product_detail_column: [products_details_arr],
      metrics_column: [
        "clicks",
        "impressions",
        "spend",
        "sales",
        "ad_sales_perc",
        "gross_sales",
        "gross_sales_seller",
        "gross_sales_vendor",
        "organic_sales",
        "organic_sales_perc",
        "orders",
        "units",
        "gross_units",
        "gross_units_seller",
        "gross_units_vendor",
        "organic_units",
        "acos",
        "tacos",
        "roas",
        "troas",
        "ctr",
        "cvr",
        "cpc",
        "aov",
        "cac",
        "gross_glanceviews"],
    };

    const token = localStorage.getItem("token");
    try {
      setLoading(true);
      const headers = {
        Authorization: `Bearer ${token}`,
      };
      let api = `${BASE_URL}dashboards/adsDashboard/tableDrawer/getComparasionOfTwoRange?brand_id=${brand_id}`;
      const result = await axios.post(api, temp_obj, { headers });
      const { results } = result?.data?.data;
      if (results?.length === 0) {

        setDataFetchingState("EMPTY");
      } else if (results.length > 0) {
        let initialTableData = [
          { matrice_name: "Impressions", backend_matrice_name: "impressions" },
          {
            matrice_name: "Clicks",
            backend_matrice_name: "clicks",
          },
          {
            matrice_name: "Spend",
            backend_matrice_name: "spend",
          },
          {
            matrice_name: "Ad Sales",
            backend_matrice_name: "sales",
          },
          {
            matrice_name: "Ad Sales %",
            backend_matrice_name: "ad_sales_perc",
          },
          {
            matrice_name: "Gross Sales",
            backend_matrice_name: "gross_sales",
          },
          {
            matrice_name: "Gross Sales (Seller)",
            backend_matrice_name: "gross_sales_seller",
          },
          {
            matrice_name: "Gross Sales (Vendor)",
            backend_matrice_name: "gross_sales_vendor",
          },
          {
            matrice_name: "Organic Sales",
            backend_matrice_name: "organic_sales",
          },
          {
            matrice_name: "Organic Sales %",
            backend_matrice_name: "organic_sales_perc",
          },
          {
            matrice_name: "Ad Orders",
            backend_matrice_name: "orders",
          },
          {
            matrice_name: "Ad Units",
            backend_matrice_name: "units",
          },
          {
            matrice_name: "Gross Units",
            backend_matrice_name: "gross_units",
          },
          {
            matrice_name: "Gross Units (Seller)",
            backend_matrice_name: "gross_units_seller",
          },
          {
            matrice_name: "Gross Units (Vendor)",
            backend_matrice_name: "gross_units_vendor",
          },
          {
            matrice_name: "Organic Units",
            backend_matrice_name: "organic_units",
          },
          {
            matrice_name: "ACOS",
            backend_matrice_name: "acos",
          },
          {
            matrice_name: "TACOS",
            backend_matrice_name: "tacos",
          },
          {
            matrice_name: "ROAS",
            backend_matrice_name: "roas",
          },
          {
            matrice_name: "TROAS",
            backend_matrice_name: "troas",
          },
          {
            matrice_name: "CTR",
            backend_matrice_name: "ctr",
          },
          {
            matrice_name: "CVR",
            backend_matrice_name: "cvr",
          },
          {
            matrice_name: "CPC",
            backend_matrice_name: "cpc",
          },
          {
            matrice_name: "AOV",
            backend_matrice_name: "aov",
          },
          {
            matrice_name: "CAC",
            backend_matrice_name: "cac",
          },
          {
            matrice_name: "Glance Views",
            backend_matrice_name: "gross_glanceviews",
          },
        ]
        let new_table_data = initialTableData.map((item) => {
          const backendName = item.backend_matrice_name;
          return {
            ...item,
            base_period: Number(results[0][`${backendName}_current`] ?? 0),
            comparison_period: Number(results[0][`${backendName}_previous`] ?? 0),
            difference: Number(results[0][`${backendName}_difference`] ?? 0),
            difference_percentage: Number(results[0][`${backendName}_difference_percentage`] ?? 0),
            selected: backendName === "acos" || backendName === "tacos" || backendName === "ctr" || backendName === "cvr" ? true : false
          };
        })
        setSel_matricesGraph(["impressions","clicks","spend","sales"]);
        setTableData(new_table_data);
        setDataFetchingState("SUCCESS");
      }
    } catch (error) {
      appError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    fetchTableData(graphTableArr[graphTableArr?.length - 1]?.type);
  },[graphTableArr[graphTableArr?.length - 1]?.name]);

  return (

    <div className='h-full w-full'>
      {loading ? (
        <div className='h-full w-full flex justify-center items-center'>
          <CircularProgress />
        </div>
      ): (
      <>
        <div
        className="flex py-2 px-3 items-center justify-between gap-2"
        style={{
            height: 72,
            borderBottom: `1px solid #EAEAED`,
            backgroundColor: "white",
        }}
        >
          <div className="h-full flex justify-between items-start w-full gap-2">
            <div
                className="self-stretch"
                style={{
                fontSize: 12,
                fontWeight: 500,
                lineHeight: "16px",
                color: BLACK.B_100,
                // flexGrow: 1
                width: "60%"
                }}
            >
                {graphTableArr?.filter(item => selproduct_details_arr.includes(item?.type)).map((item,index) => {
                  if(index === graphTableArr?.filter(item => selproduct_details_arr.includes(item?.type))?.length - 1){
                    return `${item?.name}`;
                  }
                  else {
                    return `${item?.name} > `;
                  }
                })}
            </div>
            
            <div
              className="flex h-fit items-center py-1 px-4 gap-2 rounded-[4px]"
              style={{
                border: "1px solid #EAEAED",
                position: "relative",
                // alignSelf: "center",
                // width: "324px"
              }}
            >
              <div className="flex items-center gap-2 h-fit">
                <div
                  style={{
                    color: "var(--Text-Primary-Black, #1C1C1E)",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "14px",
                    textWrap: "nowrap"
                  }}
                >
                  {`${String(InputRange?.rangeOne?.startDate?.getDate()).padStart(
                    2,
                    "0"
                  )}/${String(
                    InputRange?.rangeOne?.startDate?.getMonth() + 1
                  ).padStart(
                    2,
                    "0"
                  )}/${InputRange?.rangeOne?.startDate?.getFullYear()} - ${String(
                    InputRange?.rangeOne?.endDate?.getDate()
                  ).padStart(2, "0")}/${String(
                    InputRange?.rangeOne?.endDate?.getMonth() + 1
                  ).padStart(
                    2,
                    "0"
                  )}/${InputRange?.rangeOne?.endDate?.getFullYear()} `}
                </div>
                <div
                  style={{
                    color: "var(--Text-Primary-Grey, #97979A)",
                    fontFamily: "Inter",
                    fontSize: "8px",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "12px",
                  }}
                >
                  Vs
                </div>
                <div
                  style={{
                    color: "var(--Text-Primary-Black, #1C1C1E)",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: 500,
                    lineHeight: "14px",
                    textWrap: "nowrap"
                  }}
                >
                  {`${String(InputRange?.rangeTwo?.startDate?.getDate()).padStart(
                    2,
                    "0"
                  )}/${String(
                    InputRange?.rangeTwo?.startDate?.getMonth() + 1
                  ).padStart(
                    2,
                    "0"
                  )}/${InputRange?.rangeTwo?.startDate?.getFullYear()} - ${String(
                    InputRange?.rangeTwo?.endDate?.getDate()
                  ).padStart(2, "0")}/${String(
                    InputRange?.rangeTwo?.endDate?.getMonth() + 1
                  ).padStart(
                    2,
                    "0"
                  )}/${InputRange?.rangeTwo?.endDate?.getFullYear()} `}
                </div>
              </div>
              <img
                src={CalenderIcon}
                alt="OverView Icon"
                style={{ cursor: "pointer" }}
                // onClick={() => setDateToggle(true)}
              />
            </div>
          </div>
          <div className="flex justify-between items-center gap-2">
              <div
              className="w-fit cursor-pointer"
              onClick={() => {
                  setGraphTableToggle(false);
              }}
              >
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
              >
                  <path
                  d="M19.2806 18.2194C19.3502 18.289 19.4055 18.3718 19.4432 18.4628C19.4809 18.5539 19.5003 18.6514 19.5003 18.75C19.5003 18.8485 19.4809 18.9461 19.4432 19.0372C19.4055 19.1282 19.3502 19.2109 19.2806 19.2806C19.2109 19.3503 19.1281 19.4056 19.0371 19.4433C18.9461 19.481 18.8485 19.5004 18.7499 19.5004C18.6514 19.5004 18.5538 19.481 18.4628 19.4433C18.3717 19.4056 18.289 19.3503 18.2193 19.2806L11.9999 13.0603L5.78055 19.2806C5.63982 19.4213 5.44895 19.5004 5.24993 19.5004C5.05091 19.5004 4.86003 19.4213 4.7193 19.2806C4.57857 19.1399 4.49951 18.949 4.49951 18.75C4.49951 18.551 4.57857 18.3601 4.7193 18.2194L10.9396 12L4.7193 5.78061C4.57857 5.63988 4.49951 5.44901 4.49951 5.24999C4.49951 5.05097 4.57857 4.8601 4.7193 4.71936C4.86003 4.57863 5.05091 4.49957 5.24993 4.49957C5.44895 4.49957 5.63982 4.57863 5.78055 4.71936L11.9999 10.9397L18.2193 4.71936C18.36 4.57863 18.5509 4.49957 18.7499 4.49957C18.949 4.49957 19.1398 4.57863 19.2806 4.71936C19.4213 4.8601 19.5003 5.05097 19.5003 5.24999C19.5003 5.44901 19.4213 5.63988 19.2806 5.78061L13.0602 12L19.2806 18.2194Z"
                  fill="#1C1C1C"
                  />
              </svg>
              </div>
          </div>
        </div>
        <div className="flex w-full p-3 gap-3 flex-col items-start self-stretch" style={{
          height: "calc(100vh - 72px)"
        }}>
          <div className="w-full h-[50%]"></div>
          <div className="w-full h-[50%]">
              <div className="ag-theme-quartz" style={{
              width: "100%",
              height: "100%"
              }}>
              <AgGridReact
                  rowData={tableData}
                  columnDefs={verticalcolDefs}
                  rowHeight={32}
                  headerHeight={36}
                  getRowId={(params) => params.data.backend_matrice_name} // Must provide a unique ID
              />
              </div>
          </div>
        </div>
      </>
      )}
    </div>
  )
}

export default GraphTableDrawer